import { call, put, takeEvery } from "redux-saga/effects";

import {
  DateRangeQuery,
  PaginateQuery,
  ResponseGenerator,
} from "../../interfaces";
import {
  ADD_CALENDAR_EVENT,
  AddCalendarEventAction,
  DELETE_CALENDAR_EVENT,
  DeleteCalendarEventAction,
  GET_ALL_CALENDAR_EVENTS,
  GET_CALENDAR_EVENT,
  GET_CALENDAR_EVENTS,
  GetAllCalendarEventsAction,
  GetCalendarEventAction,
  GetCalendarEventsAction,
  UPDATE_CALENDAR_EVENT,
  UpdateCalendarEventAction,
} from "./actionTypes";
import {
  addCalendarEventError,
  addCalendarEventSuccess,
  deleteCalendarEventError,
  deleteCalendarEventSuccess,
  getAllCalendarEventsError,
  getAllCalendarEventsSuccess,
  getCalendarEventError,
  getCalendarEventSuccess,
  getCalendarEventsError,
  getCalendarEventsSuccess,
  updateCalendarEventError,
  updateCalendarEventSuccess,
} from "./actions";
import {
  addCalendarEvent,
  deleteCalendarEvent,
  getAllCalendarEvents,
  getCalendarEvent,
  getCalendarEvents,
  updateCalendarEvent,
} from "../../helpers/backend_helper";

function* getCalendarEventsSaga({
  payload: { request, history },
}: GetCalendarEventsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getCalendarEvents,
      request as PaginateQuery
    );
    yield put(getCalendarEventsSuccess(response.data));
  } catch (error) {
    yield put(getCalendarEventsError(error));
  }
}

function* getAllCalendarEventsSaga({
  payload: { history },
}: GetAllCalendarEventsAction) {
  try {
    const response: ResponseGenerator = yield call(getAllCalendarEvents);
    yield put(getAllCalendarEventsSuccess(response.data));
  } catch (error) {
    yield put(getAllCalendarEventsError(error));
  }
}

function* getCalendarEventSaga({
  payload: { id, history },
}: GetCalendarEventAction) {
  try {
    const response: ResponseGenerator = yield call(getCalendarEvent, id);
    yield put(getCalendarEventSuccess(response.data));
  } catch (error) {
    yield put(getCalendarEventError(error));
  }
}

function* addCalendarEventSaga({
  payload: { request, history },
}: AddCalendarEventAction) {
  try {
    const response: ResponseGenerator = yield call(addCalendarEvent, request);
    yield put(addCalendarEventSuccess(response.data));
  } catch (error) {
    yield put(addCalendarEventError(error));
  }
}

function* updateCalendarEventSaga({
  payload: { id, request, history },
}: UpdateCalendarEventAction) {
  try {
    const response: ResponseGenerator = yield call(
      updateCalendarEvent,
      id,
      request
    );
    yield put(updateCalendarEventSuccess(response.data));
  } catch (error) {
    yield put(updateCalendarEventError(error));
  }
}

function* deleteCalendarEventSaga({
  payload: { id, history },
}: DeleteCalendarEventAction) {
  try {
    yield call(deleteCalendarEvent, id);
    yield put(deleteCalendarEventSuccess(id));
  } catch (error) {
    yield put(deleteCalendarEventError(error));
  }
}

function* CalendarEventSaga() {
  yield takeEvery(GET_CALENDAR_EVENTS, getCalendarEventsSaga);
  yield takeEvery(GET_ALL_CALENDAR_EVENTS, getAllCalendarEventsSaga);
  yield takeEvery(GET_CALENDAR_EVENT, getCalendarEventSaga);
  yield takeEvery(ADD_CALENDAR_EVENT, addCalendarEventSaga);
  yield takeEvery(UPDATE_CALENDAR_EVENT, updateCalendarEventSaga);
  yield takeEvery(DELETE_CALENDAR_EVENT, deleteCalendarEventSaga);
}

export default CalendarEventSaga;
